// extracted by mini-css-extract-plugin
export default {"narrow_field":"NewOrganizationModalForm_narrow_field__SlWzj"};